export enum LoadingStates {
    NOT_STARTED = 1,
    BUSY_LOADING = 2,
    LAST_LOADING_OK = 3,
    LAST_LOADING_ERROR = 4,
}
